import { _ as y } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.assign-7e79fd7b.js";
import { c as h } from "./index-8b07dec9.js";
import g from "react";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as v } from "./getMetrics-953aa4f8.js";
import { HelperText as I } from "./helperText.js";
import o, { css as c } from "styled-components";
import { a as N } from "./index-5d0f31c6.js";
import { jsxs as n, jsx as p } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./es.string.trim-6e13db75.js";
import "./string-trim-14e37ad3.js";
import "./es.object.keys-9d66766f.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./array-slice-79f93c56.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "@ucl/shared-component-foundations";
import "@ucl/shared-icons";
var j = /* @__PURE__ */ o.div.withConfig({
  displayName: "switchstyles__Switch",
  componentId: "sc-56nqqj-0"
})(["&.Switch{", ";}"], function(i) {
  var t = i.theme.components.switch;
  return c(t.Switch);
}), q = /* @__PURE__ */ o.label.withConfig({
  displayName: "switchstyles__InputWrapper",
  componentId: "sc-56nqqj-1"
})(["&.Switch__input-wrapper{", ";}"], function(i) {
  var t = i.theme.components.switch;
  return c(t.SwitchInputWrapper);
}), x = /* @__PURE__ */ o.input.withConfig({
  displayName: "switchstyles__SwitchInput",
  componentId: "sc-56nqqj-2"
})(["&.Switch__input{", ";}"], function(i) {
  var t = i.theme.components.switch;
  return c(t.SwitchInput);
}), C = /* @__PURE__ */ o.span.withConfig({
  displayName: "switchstyles__SwitchSlider",
  componentId: "sc-56nqqj-3"
})(["&.Switch__slider{", ";}"], function(i) {
  var t = i.theme.components.switch;
  return c(t.SwitchSlider);
}), l = /* @__PURE__ */ o(N).withConfig({
  displayName: "switchstyles__SwitchSliderIcon",
  componentId: "sc-56nqqj-4"
})(["&.Switch__slider-icon{", ";}"], function(i) {
  var t = i.theme.components.switch;
  return c(t.SwitchSliderIcon);
}), b = ["size", "inputState", "helperTextProp", "className"], k = function(t, w) {
  var s = t.size, d = s === void 0 ? "medium" : s, m = t.inputState, a = t.helperTextProp, S = a === void 0 ? {
    inputState: m
  } : a, u = t.className, e = y(t, b), _ = v({
    label: "Switch"
  }), f = function(r) {
    e.onKeyDown == null || e.onKeyDown(r), !(r.code !== "Enter" || e.disabled) && (e.checked === void 0 && (r.target.checked = !r.target.checked), e.onChange == null || e.onChange(r));
  };
  return /* @__PURE__ */ n(j, Object.assign({
    className: h(["Switch", u])
  }, _, {
    children: [/* @__PURE__ */ n(q, {
      className: h(["Switch__input-wrapper", "Switch__input-wrapper--" + d]),
      children: [/* @__PURE__ */ p(x, Object.assign({
        ref: w,
        role: "switch",
        type: "checkbox",
        "aria-label": "toggle switch"
      }, e, {
        onKeyDown: f,
        className: "Switch__input"
      })), /* @__PURE__ */ n(C, {
        className: "Switch__slider",
        children: [/* @__PURE__ */ p(l, {
          icon: "checkmark",
          className: "Switch__slider-icon Switch__slider-icon--checked"
        }), /* @__PURE__ */ p(l, {
          icon: "cancelClose",
          className: "Switch__slider-icon Switch__slider-icon--unchecked"
        })]
      })]
    }), /* @__PURE__ */ p(I, Object.assign({}, S, {
      inputState: m
    }))]
  }));
}, jt = /* @__PURE__ */ g.forwardRef(k);
export {
  jt as Switch
};
